import { createFileRoute } from '@tanstack/react-router';
import OrdersManagement from '../../components/manager/OrdersManagement';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/')({
  component: StaffHomeRoute,
});

function StaffHomeRoute() {
  return (
    <StaffPortal>
      <OrdersManagement />
    </StaffPortal>
  );
}
